import script from "./CustomTableTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTableTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CustomTableTemplate.vue?vue&type=style&index=0&id=096ff590&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-096ff590"]])

export default __exports__